import { makeStyles } from '@material-ui/core';

// OPS-95 — Edgebeam horizontal logo for sidebar (drawer-open).
// Source SVG: 20251218_EdgeBeam_Brand Guidelines/Horizontal Logos/
//             EdgeBeamWireless_Logo_White_Full Color.svg
// Hybrid: white EDGEBEAM wordmark + gradient on the WIRELESS subtype.
// Designed for dark backgrounds (sidebar Ink #071D49).
const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 339 65"
      role="img"
      aria-label="Edgebeam Wireless"
    >
      <defs>
        <linearGradient
          id="edgebeam-logo-full-grad"
          x1="224.4"
          y1="20.6"
          x2="338.3"
          y2="20.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="0.3" stopColor="#89BFDF" />
          <stop offset="0.7" stopColor="#F6CA54" />
          <stop offset="1" stopColor="#EF8F48" />
        </linearGradient>
      </defs>

      <g fill="#FFFFFF">
        <polygon points="238.7 60.6 235.5 50.7 233.5 50.7 230.3 60.6 227.1 50.8 224.6 50.8 229.2 64.1 231.2 64.1 234.5 54.6 237.7 64.1 239.7 64.1 244.3 50.8 241.9 50.8 238.7 60.6" />
        <rect x="248.7" y="50.8" width="2.3" height="13.2" />
        <path d="M267.2,55h0c0-1.2-.4-2.2-1.1-2.9-.8-.8-2.1-1.3-3.8-1.3h-5.9v13.2h2.3v-4.6h2.9l3.2,4.6h2.8l-3.6-5c1.8-.5,3.1-1.8,3.1-4ZM258.7,57.3v-4.4h3.4c1.7,0,2.7.8,2.7,2.2h0c0,1.4-1.1,2.2-2.7,2.2h-3.4Z" />
        <polygon points="274.3 58.4 280.9 58.4 280.9 56.3 274.3 56.3 274.3 52.9 281.7 52.9 281.7 50.8 271.9 50.8 271.9 64 281.8 64 281.8 61.9 274.3 61.9 274.3 58.4" />
        <polygon points="288.8 50.8 286.5 50.8 286.5 64 295.7 64 295.7 61.9 288.8 61.9 288.8 50.8" />
        <polygon points="302.3 58.4 308.9 58.4 308.9 56.3 302.3 56.3 302.3 52.9 309.8 52.9 309.8 50.8 300 50.8 300 64 309.9 64 309.9 61.9 302.3 61.9 302.3 58.4" />
        <path d="M319.6,56.3c-2.5-.6-3.2-1.1-3.2-2.1h0c0-.9.8-1.6,2.2-1.6s2.4.5,3.6,1.4l1.2-1.8c-1.3-1.1-2.9-1.7-4.8-1.7s-4.5,1.6-4.5,3.8h0c0,2.5,1.6,3.3,4.4,4,2.4.6,3,1.1,3,2h0c0,1-.9,1.7-2.3,1.7s-2.9-.6-4.2-1.7l-1.4,1.7h0c1.6,1.4,3.5,2.1,5.5,2.1s4.7-1.5,4.7-3.9h0c0-2.2-1.4-3.2-4.2-3.9Z" />
        <path d="M333.4,56.3c-2.5-.6-3.1-1.1-3.1-2.1h0c0-.9.8-1.6,2.2-1.6s2.4.5,3.6,1.4l1.2-1.8c-1.3-1.1-2.9-1.7-4.8-1.7s-4.5,1.6-4.5,3.8h0c0,2.5,1.6,3.3,4.4,4,2.4.6,3,1.1,3,2h0c0,1-.9,1.7-2.3,1.7s-2.9-.6-4.2-1.7l-1.4,1.7h0c1.6,1.4,3.5,2.1,5.5,2.1s4.7-1.5,4.7-3.9h0c0-2.2-1.4-3.2-4.2-3.9Z" />
      </g>

      <g fill="#FFFFFF">
        <polygon points="7.2 23.9 24.8 23.9 24.8 17.3 0 17.3 0 40.8 30.1 40.8 30.1 34.4 7.2 34.4 7.2 23.9" />
        <rect y="0.7" width="29.8" height="6.4" />
        <path d="M51.6.7h-15v40.1h15c6,0,11.5-2.1,15.4-5.8,3.8-3.7,5.9-8.7,5.9-14.3h0c0-11.7-9-20.1-21.3-20.1ZM65.4,20.7h0c0,3.9-1.3,7.3-3.8,9.7-2.5,2.5-6,3.8-10,3.8h-7.8V7.3h7.8c8.1,0,13.8,5.5,13.8,13.5Z" />
        <path d="M97.7,24.7h10.2v7.3c-2.6,1.9-6,3-9.6,3-7.9,0-13.5-5.8-13.5-14.2h0c0-3.8,1.3-7.3,3.7-9.9,2.4-2.7,5.7-4.1,9.2-4.1,5.1,0,8.1,1.7,11.1,4.2h0c0,0,4.6-5.4,4.6-5.4h0c-4.6-3.9-9-5.5-15.4-5.5s-11,2.2-14.9,6.2c-3.7,3.9-5.8,9-5.8,14.6h0c0,5.9,2,11.1,5.7,14.8,3.8,3.9,9,5.9,15.1,5.9,7.8,0,13.4-3.4,16.7-6.2h0v-16.9h-17.2v6.3Z" />
        <polygon points="128.8 23.9 146.4 23.9 146.4 17.3 128.8 17.3 128.8 7.1 151.4 7.1 151.4 .7 121.6 .7 121.6 40.8 151.7 40.8 151.7 34.4 128.8 34.4 128.8 23.9" />
        <path d="M183.9,19.9c3.8-2,5.6-4.9,5.6-8.9h0c0-2.8-.9-5-2.7-6.8-2.3-2.3-6-3.6-10.5-3.6h-18v40.1h18.6c9.3,0,14.9-4.1,14.9-11h0c0-4.9-2.5-8-7.8-9.8ZM182.3,12.2c0,3.4-2.7,5.3-7.4,5.3h-9.5V7.1h10c4.4,0,6.9,1.8,6.9,5h0ZM184.5,28.9h0c0,3.5-2.8,5.5-7.6,5.5h-11.6v-10.8h11c5.3,0,8.1,1.8,8.1,5.3Z" />
        <polygon points="227 7.1 227 .7 197.2 .7 197.2 40.8 219.1 40.8 219.1 34.4 204.4 34.4 204.4 23.9 222 23.9 222 17.3 204.4 17.3 204.4 7.1 227 7.1" />
      </g>

      <path
        fill="url(#edgebeam-logo-full-grad)"
        d="M331.1,30.9h0c-1.2,2.1-3.6,3.2-5.9,2.7-2.1-.4-3.7-2-4.3-4.1-.8-3.1-1.6-7-2.1-9.6-2.2-11-3.9-19.7-10-19.7-6.1,0-7.8,8.7-10,19.7-.8,4.2-2.1,10.4-3.3,13.2-1.3-2.8-2.5-9-3.3-13.2-2.2-11-3.9-19.7-10-19.7-6.1,0-7.8,8.7-10,19.7-.6,2.9-1.3,6.8-2.2,9.9h0c0,0,0,0,0,0-.1.5-1,4-3.9,4.1h-.1c-1.7,0-3.1-1.4-4.3-4.3L248.7.4h-6.6l-17.6,40.3h0c0,.1,7.4.1,7.4.1l4.1-9.6h18.8l.8,1.8h0c1.9,4.8,6,7.9,10.4,7.9s.1,0,.2,0c0,0,.1,0,.2,0h.2c7.4,0,10.1-9.5,10.1-9.6.8-3,1.6-6.6,2.2-10h0c.8-4.2,2.1-10.5,3.3-13.2,1.3,2.8,2.5,9,3.3,13.2,2.2,11,3.9,19.7,10,19.7h0c6.1,0,7.8-8.7,10-19.7h0c.8-4.2,2-10.5,3.3-13.2,1.3,2.8,2.5,9,3.3,13.2.7,3.4,1.3,6.5,2,9.2h0s0,0,0,0c0,0,0,0,0,0,0,0,0,.2,0,.2,0,0,0,.2,0,.3h0c1.2,4.8,4.8,8.3,9.5,9.2.8.2,1.6.2,2.4.2,5.7,0,10.7-4,12-9.6h0c0-.1-7.2-.1-7.2-.1ZM252,24.8h-13.5l6.7-15.7,6.8,15.7Z"
      />
    </svg>
  );
};
